import React from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import Button from "./Button";
import { SafeHtmlParser } from "./SafeHtmlParser";

const Faq = ({
	heading,
	body,
	faqs,
	button,
	secondHeading,
	secondBody,
	colour,
}) => {
	return (
		<section className="py-5">
			<Container>
				{/* Heading Section */}
				<Row className="mb-lg-5 mb-3">
					<Col>
						<div style={{ color: colour }}>
							<h2 className="display-5 ">{heading}</h2>
						</div>
						<p>{body}</p>
					</Col>
				</Row>

				{/* Accordion Section */}
				<Row>
					<Col xs={12} className="mx-auto">
						<Accordion style={{ borderRadius: "0px" }}>
							{faqs.map((faq, index) => (
								<Accordion.Item
									eventKey={index.toString()}
									key={faq.id}
									className="custom-accordion-item"
								>
									<Accordion.Header>
										<strong>{faq.faqFields.question}</strong>
									</Accordion.Header>
									<Accordion.Body>
										<Row>
											<Col lg={8}>
												<SafeHtmlParser htmlContent={faq.faqFields.answer} />
											</Col>
										</Row>
									</Accordion.Body>
								</Accordion.Item>
							))}
						</Accordion>
					</Col>
				</Row>

				{/* Call-to-Action Button */}

				<Row className="mt-5 mt-lg-7">
					<Col>
						<div style={{ color: colour }}>
							<h3 className="mb-2 ">{secondHeading}</h3>
						</div>
						<SafeHtmlParser htmlContent={secondBody} />
						{button && (
							<Button
								width="w-100 w-md-auto"
								colour={colour}
								text={button.title}
								link={button.url}
								isOutline={true}
							/>
						)}
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default Faq;
